module.exports = __webpack_public_path__ + "static/media/2017_conf_Lean_Product_in_a_Huge_Company.244bd358.png";